// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3dSQY","unreadBadge":"styles_unreadBadge__x5MfO","modalContent":"styles_modalContent__3SfLK","modal":"styles_modal__2LPaa"};